module.exports = __webpack_public_path__ + "static/img/sg2.5618852.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/sg2.png
// module id = /JFF
// module chunks = 7